import type { FunctionComponent } from 'react'

import { useLocalizedSignIn } from '../../../hooks/useLocalizedSignIn'
import { useTranslate } from '../../contexts/TranslationContext'
import { useAuth } from '../../user/UserContext'
import { InfoModal } from './InfoModal'

type LoginModalProps = {
	closeModal: () => void
	isModalOpen: boolean
}

export const LoginModal: FunctionComponent<LoginModalProps> = ({ closeModal, isModalOpen }) => {
	const translate = useTranslate()
	const { signIn } = useLocalizedSignIn()

	const auth = useAuth()
	const notSigned = auth.status !== 'signedIn'

	return (
		<InfoModal
			title={notSigned ? translate('loginToReview.modal.title') : translate('loginToReview.modal.title.registration')}
			lead={
				notSigned ? translate('loginToReview.modal.subtitle') : translate('loginToReview.modal.subtitle.registration')
			}
			imageUrl="/images/pes_modal_5.jpg"
			buttonLabel={
				notSigned
					? translate('loginToReview.modal.button.login')
					: translate('loginToReview.modal.button.login.registration')
			}
			buttonType="button"
			isOpen={isModalOpen}
			imageAlternativeText={translate('loginToReview.modal.alt.image')}
			onClick={
				notSigned
					? () => {
							closeModal()
							signIn()
						}
					: closeModal
			}
			closeModal={closeModal}
		/>
	)
}
